import React from 'react'
import AppScreenshot from '../resources/app_screenshot.jpg'
import AgTechCard from '@agtech/web/components/Cards/AgTechCard'
import AgTechLandingPageHeader from '@agtech/web/components/App/Landing/AgTechLandingPageHeader'
import { useAgTechAuthContext } from '@agtech/core/auth/AgTechAuthContext'
import { useAgTechWebNavigation } from '@agtech/web/components/App/Functions/AgTechNavigation'
import AgTechWebAppBackdrop from '@agtech/web/components/App/Loading/AgTechWebAppBackdrop'
import BackgroundImage from '../resources/Landing.jpg';

const SalesLanding = () => {
    const authContext = useAgTechAuthContext();
    const navigation = useAgTechWebNavigation();

    return (
        <div className='stretched row-based scrollable flex'>
            <div className="bg-primary stretched centered bg-cover flex" style={{
                backgroundImage: `url(${BackgroundImage})`,
            }}>
            <div className='stretched row-based bg-tinted flex'>
                <AgTechLandingPageHeader />
                <div className='wide centered flexed pb-10 flex'>
                    <div className='flexed w-[560px] row-based items-center mt-[36px] flex'>
                        <h1 className='text-white text-6xl font-semibold mb-3'>
                            Sellabull
                        </h1>
                        <p className='text-white centered text-xl'>
                            Modern livestock sale management.
                        </p>
                        <div className='mt-[72px]'>
                            {authContext.isUserAuthenticated() ? (
                                <button
                                    onClick={() => navigation.goTo('/app')}
                                    className='bg-highlight-600 border border-highlight rounded py-4 px-6 clickable text-md font-semibold text-white'
                                >
                                    Go to application
                                </button>
                            ) : (
                                <div className='column-based flex'>
                                    <button
                                        className='bg-highlight-600 border border-highlight mr-4 rounded py-4 px-6 clickable text-md font-semibold text-white'
                                    >
                                        Get started for free
                                    </button>
                                    <button
                                        onClick={() => authContext.loginUser()}
                                        className='border border-highlight rounded py-4 px-6 clickable text-md font-semibold text-white'
                                    >
                                        Have an account? Sign in.
                                    </button>
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            </div>
            </div>
        </div>
    )
}

export default SalesLanding